import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAdminAuth } from '../hooks';
import { routes } from '../routing';

export const AdminNoAuthLayout: React.FC = () => {
  const { isAuthenticated } = useAdminAuth();

  if (isAuthenticated) {
    return <Navigate to={routes.adminDashboard} replace />;
  }

  return <Outlet />;
};
